export default __webpack_public_path__ + "static/media/4-blue-energy.edd29189.png";